var generateStyle = function generateStyle(componentTheme) {
  return {
    interactionType: {
      padding: "".concat(componentTheme.searchInteractionsPaddingTopBottom, " ").concat(componentTheme.searchInteractionsPaddingLeftRight)
    },
    filterContainer: {
      display: 'flex',
      marginTop: '1rem'
    },
    filterColumn: {
      flex: 1,
      marginRight: '2rem'
    }
  };
};
export default generateStyle;